import React, { FC } from 'react';
import { useBeforeunload } from 'react-beforeunload';
import { Prompt } from 'react-router-dom';

interface Props {
  condition: boolean;
  message: string;
}

const AskBeforeLeaving: FC<Props> = ({ condition = true, message }) => {
  useBeforeunload((event) => {
    if (condition) {
      event.preventDefault();
      return message;
    }
  });

  return <Prompt message={message} when={condition} />;
};

export default AskBeforeLeaving;
